import { useState, useRef, useEffect } from "react";
import {
    Col,
    Container,
    Row,
    Image,
    Card,
    Button,
    Form,
} from "react-bootstrap";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import SchoolHeader from "../components/SchoolHeader";
import StudentHeader from "../components/StudentHeader";
import HospitalHeader from "../components/HospitalHeader";
import young_beautiful from "../assets/images/young_beautiful.jpg";
import axios from "axios";

import {
    FaMapMarkerAlt,
    FaPhoneAlt,
    FaEnvelope,
    FaGlobeAsia,
} from "react-icons/fa";
import { showSuccessMessage } from "../services/utils";

const ContactUs = (props) => {
    const BaseURL = process.env.REACT_APP_BASE_URL
    const title = localStorage.getItem("PageTittle")
    const token = localStorage.getItem("token")
    const [contactUsData, setContactUsData] = useState()
    useEffect(() => {
        try {
            axios.get(`${BaseURL}users/getContactUs`).then(res => setContactUsData(res.data.data))

        } catch (error) {
            console.log(error)

        }
    }, [])
    const containerRef = useRef(null);

    const [formdetail, setFormdetail] = useState({
        Message: "",
        name: "",
        email: "",
        Subject: "",
        type: "email",
    })

    const contactFormDetails = (e) => {
        const name = e.target.name
        const value = e.target.value
        setFormdetail({
            ...formdetail,
            [name]: value
        })
    }

    const ContactData = (e) => {
        e.preventDefault()
        try {
            axios.post(`${BaseURL}users/userQueries`, formdetail).then(res => showSuccessMessage({ message: "Thanks for reaching us we will get back to you soon" }))

        } catch (error) {
            console.log(error)

        }
        console.log(formdetail)
        setFormdetail({
            Message: "",
            name: "",
            email: "",
            Subject: "",
            type: "email",
        })
    }



    useEffect(() => {
        props.call == "true" ? containerRef.current.focus() : window.scrollTo(0, 0);
    }, [props.call]);

    return (
        <div className="cnt_repns">
            {title === "School" && token && <SchoolHeader />}
            {title === "Hospital" && token && <HospitalHeader />}
            {title === "Student" && token && <StudentHeader />}
            {!token && <Header />}
            <section className="bnner_imgswork py-5">
                <div className="cntctbnnr_img text-center">
                    <h1>Contact Us</h1>
                    <div className="innner_hmm text-center">
                        <Breadcrumb>
                            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                            <Breadcrumb.Item active>Contact</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </div>
            </section>
            <section className="sctn_pdng">
                <Container>
                    <div className="contact_hom">
                        <div className="hom_cont text-center"  >
                            <h1>Get in Touch</h1>
                            <p>
                                Want to get in touch? We'd love to hear from
                                you. Here's how you can reach us...
                            </p>
                        </div>
                        <Row className="justify-content-center">
                            <Col md={4}>
                                <div className="diviconloc w-100">
                                    <div className="divloct mt-4">
                                        <FaMapMarkerAlt />
                                    </div>
                                    <div className="text_addres text-center">
                                        <strong>Address:</strong>
                                        <p>
                                            {contactUsData?.address}
                                        </p>
                                    </div>
                                </div>
                            </Col>
                            <Col md={5}>
                                <div className="diviconloc w-100">
                                    <div className="divloct mt-4">
                                        <FaEnvelope />
                                    </div>
                                    <div className="text_addres text-center">
                                        <strong>Email:</strong>
                                        <p>
                                            {contactUsData?.email}
                                        </p>
                                    </div>
                                </div>
                            </Col>
                            <Col md={3}>
                                <div className="diviconloc w-100">
                                    <div className="divloct mt-4">
                                        <FaGlobeAsia />
                                    </div>
                                    <div className="text_addres text-center">
                                        <strong>Website:</strong>
                                        <p>{contactUsData?.website}</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </section>
            <section className="cntct_form"  >
                <Container>
                    <Card className="card_custmmr" ref={containerRef} tabIndex={-1}>
                        <div className="divformm"  >
                            <Row>
                                <Col md={6}>
                                    <div className="coldivv">
                                        <Form className="signform_div" onSubmit={(e)=> ContactData(e)}>
                                            <Row>
                                                <Col md={6} >
                                                    <Form.Group className="mb-3">
                                                        <Form.Label  >
                                                            Your Name
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="name"
                                                            placeholder="Your Name"
                                                            required
                                                            name="name"
                                                            value={formdetail.name}
                                                            onChange={(e) => { contactFormDetails(e) }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>
                                                            Your Email
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="email"
                                                            placeholder="Your Email"
                                                            required
                                                            name="email"
                                                            value={formdetail ? formdetail.email : ""}
                                                            onChange={(e) => { contactFormDetails(e) }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>
                                                            Subject
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="textarea"
                                                            placeholder="Subject"
                                                            name="Subject"
                                                            required
                                                            value={formdetail ? formdetail.Subject : ""}
                                                            onChange={(e) => { contactFormDetails(e) }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col md={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>
                                                            Message
                                                        </Form.Label>
                                                        <Form.Control
                                                            as="textarea"
                                                            rows={3}
                                                            required
                                                            value={formdetail ? formdetail.Message : ""}
                                                            name="Message"
                                                            onChange={(e) => { contactFormDetails(e) }}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Button
                                                    className="btn_theme w-100 mt-4"
                                                    type="submit"
                                                    variant=""
                                                >
                                                    Send Message
                                                </Button>
                                            </Row>
                                        </Form>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    {/* <div className="mapcol">
                                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2822.7806761080233!2d-93.29138368446431!3d44.96844997909819!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x52b32b6ee2c87c91%3A0xc20dff2748d2bd92!2sWalker+Art+Center!5e0!3m2!1sen!2sus!4v1514524647889"  allowfullscreen></iframe>
                                    </div> */}
                                    <div className="rowimgg" >
                                        <div className="youngg_doctt">
                                            <Image
                                                src={young_beautiful}
                                                fluid
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Card>
                </Container>
            </section>

            <Footer />
        </div>
    );
};
export default ContactUs;
